import { useEffect } from "react";
import { useAuth } from "./useAuth";
import { useLicenseStatus } from "./useLicenseStatus";
import type { Visiteur } from "../nav/navHeader";
import { installerRappelPartage } from "./partagePremium";

/**
 * Pose html[data-visiteur] dans l'application, comme nav.js sur les pages serveur : la règle
 * « Premium sans rappel d'accès » de km.css (décision du 22/10/2026) et les îlots lisent le même
 * attribut. Rien tant que la session ou la licence se charge.
 */
export function usePublierVisiteur(): void {
  const { authState } = useAuth();
  const connecte = authState.type === "authenticated";
  const { data: licence } = useLicenseStatus();
  const visiteur: Visiteur | null =
    authState.type === "unauthenticated" ? "anonyme"
    : connecte && licence ? (licence.hasFullAccess === true ? "premium" : "gratuit")
    : null;

  useEffect(() => {
    if (visiteur) document.documentElement.dataset.visiteur = visiteur;
  }, [visiteur]);

  // Abonné : filigrane à l'impression et rappel après Impr. écran (partagePremium.ts), rien de bloqué.
  const email = connecte ? authState.user?.email ?? null : null;
  useEffect(() => {
    if (visiteur !== "premium" || !email) return undefined;
    return installerRappelPartage(document, email);
  }, [visiteur, email]);
}
